import React from "react";
import { Link } from "react-router-dom";
import { Typewriter } from "react-simple-typewriter";
import ProfileImage from "../assets/ProfileImage.png";
import { motion } from "framer-motion";
import myJourney from "../config/myJourney";
import useMeta from "../hooks/useMeta";
import siteConfig from "../config/siteConfig";
import playStoreBadge from "../assets/GetItOnGooglePlayStoreBadge.png";
function Home() {
  useMeta({
    title: "Satyam Jha | Android Developer — Founder of JointerX",
    description:
      "Hi, I am Satyam Jha — Founder & Developer of JointerX. Android & Web Developer skilled in Kotlin, React, Firebase, and Spring Boot. Explore my projects, skills, and portfolio, or get in touch for collaborations.",
    keywords:
      "Satyam Jha, Android Developer, Spring Boot Developer, Web Developer, Portfolio, Firebase, Kotlin, React, Android, JointerX Founder",
    canonical: "https://satyamjha.in/",
  });
  return (
    <div className="bg-gradient-to-br dark:from-gray-800 dark:to-gray-900 pb-20">
      <div className="flex h-auto lg:min-h-screen xl:min-h-screen sm:h-auto md:h-auto px-2 ">
        <div className="flex flex-col items-center basis-full  lg:basis-2/3 xl:basis-2/3  ">
          <motion.div
            initial={{ opacity: 0, y: 0 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className=" text-gray-800  dark:text-white text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-5xl font-sans font-bold "
          >
            <p className="mt-[4.7rem] lg:mt-20 xl:mt-20">Hi,</p>
            <div className="flex mt-2 lg:mt-6 xl:mt-6 md:mt-4">
              <p className="">
                I’am&nbsp;
                <span className="text-blue-600 ml">Satyam Jha</span>
              </p>
            </div>
            <div className=" mt-2 lg:mt-6 xl:mt-6 md:mt-4 min-h-[3rem]">
              <span className="block lg:w-[520px] xl:w-[520px] md:w-[370px] sm:w-[310px] w-[245px]">
                <Typewriter
                  words={[
                    "a Android Developer",
                    "a Founder",
                    "a Web Developer",
                    "a Author",
                  ]}
                  loop={0} // 0 = infinite
                  cursor
                  cursorStyle="|"
                  typeSpeed={90}
                  deleteSpeed={65}
                  delaySpeed={1500}
                />
              </span>
            </div>
            <div className="lg:text-lg xl:text-lg md:text-sm mt-4 lg:mt-9 xl:mt-9 md:mt-6 text-xs ">
              <Link
                to="/Contact"
                className="rounded-md  font-sans bg-blue-600  px-16 py-1.5 text-sky-50 font-bold hover:bg-blue-900"
              >
                Contact
              </Link>
            </div>
            <div className="flex space-x-3 mt-5 ml-1">
              {/*Linkedin*/}
              <a
                target="_blank"
                href={siteConfig.social.linkedin}
                className="text-gray-800 dark:text-gray-200 hover:text-blue-500 dark:hover:text-blue-400"
              >
                <span className="sr-only">LinkedIn</span>
                <svg
                  className="h-4 w-4 sm:h-1.15rem sm:w-1.15rem md:h-5 md:w-5 lg:h-5 lg:w-5 "
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"
                    clipRule="evenodd"
                  />
                </svg>
              </a>

              {/*Instagram*/}
              <a
                target="_blank"
                href={siteConfig.social.instagram}
                className="text-gray-800 dark:text-gray-200 hover:text-blue-500 dark:hover:text-blue-400"
              >
                <span className="sr-only">Instagram</span>
                <svg
                  className="h-4 w-4 sm:h-1.15rem sm:w-1.15rem md:h-5 md:w-5 lg:h-5 lg:w-5 "
                  fill="currentColor"
                  viewBox="0 0 640 640"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M320.3 205C256.8 204.8 205.2 256.2 205 319.7C204.8 383.2 256.2 434.8 319.7 435C383.2 435.2 434.8 383.8 435 320.3C435.2 256.8 383.8 205.2 320.3 205zM319.7 245.4C360.9 245.2 394.4 278.5 394.6 319.7C394.8 360.9 361.5 394.4 320.3 394.6C279.1 394.8 245.6 361.5 245.4 320.3C245.2 279.1 278.5 245.6 319.7 245.4zM413.1 200.3C413.1 185.5 425.1 173.5 439.9 173.5C454.7 173.5 466.7 185.5 466.7 200.3C466.7 215.1 454.7 227.1 439.9 227.1C425.1 227.1 413.1 215.1 413.1 200.3zM542.8 227.5C541.1 191.6 532.9 159.8 506.6 133.6C480.4 107.4 448.6 99.2 412.7 97.4C375.7 95.3 264.8 95.3 227.8 97.4C192 99.1 160.2 107.3 133.9 133.5C107.6 159.7 99.5 191.5 97.7 227.4C95.6 264.4 95.6 375.3 97.7 412.3C99.4 448.2 107.6 480 133.9 506.2C160.2 532.4 191.9 540.6 227.8 542.4C264.8 544.5 375.7 544.5 412.7 542.4C448.6 540.7 480.4 532.5 506.6 506.2C532.8 480 541 448.2 542.8 412.3C544.9 375.3 544.9 264.5 542.8 227.5zM495 452C487.2 471.6 472.1 486.7 452.4 494.6C422.9 506.3 352.9 503.6 320.3 503.6C287.7 503.6 217.6 506.2 188.2 494.6C168.6 486.8 153.5 471.7 145.6 452C133.9 422.5 136.6 352.5 136.6 319.9C136.6 287.3 134 217.2 145.6 187.8C153.4 168.2 168.5 153.1 188.2 145.2C217.7 133.5 287.7 136.2 320.3 136.2C352.9 136.2 423 133.6 452.4 145.2C472 153 487.1 168.1 495 187.8C506.7 217.3 504 287.3 504 319.9C504 352.5 506.7 422.6 495 452z"
                    clipRule="evenodd"
                  />
                </svg>
              </a>
              {/*GitHub*/}
              <a
                target="_blank"
                href={siteConfig.social.github}
                className="text-gray-800 dark:text-gray-200 hover:text-blue-500 dark:hover:text-blue-400"
              >
                <span className="sr-only">GitHub</span>
                <svg
                  className="h-4 w-4 sm:h-1.15rem sm:w-1.15rem md:h-5 md:w-5 lg:h-5 lg:w-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
                    clipRule="evenodd"
                  />
                </svg>
              </a>
              {/*Play Store*/}
              <a
                target="_blank"
                href={siteConfig.social.playstore}
                className="text-gray-800 dark:text-gray-200 hover:text-blue-500 dark:hover:text-blue-400"
              >
                <span className="sr-only">Google Play Store</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 sm:h-1.15rem sm:w-1.15rem md:h-5 md:w-5 lg:h-5 lg:w-5"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                  aria-hidden="true"
                >
                  <path d="M14.222 9.374c1.037-.61 1.037-2.137 0-2.748L11.528 5.04 8.32 8l3.207 2.96zm-3.595 2.116L7.583 8.68 1.03 14.73c.201 1.029 1.36 1.61 2.303 1.055zM1 13.396V2.603L6.846 8zM1.03 1.27l6.553 6.05 3.044-2.81L3.333.215C2.39-.341 1.231.24 1.03 1.27" />
                </svg>
              </a>
              {/*LeetCode*/}
              <a
                target="_blank"
                href={siteConfig.social.leetcode}
                className="text-gray-800 dark:text-gray-200 hover:text-blue-500 dark:hover:text-blue-400"
              >
                <span className="sr-only">LeetCode</span>
                <svg
                  className="h-4 w-4 sm:h-1.15rem sm:w-1.15rem md:h-5 md:w-5 lg:h-5 lg:w-5"
                  version="1.0"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24.000000 24.000000"
                  preserveAspectRatio="xMidYMid meet"
                >
                  {" "}
                  <g
                    transform="translate(0.000000,24.000000) scale(0.100000,-0.100000)"
                    fill="currentColor"
                    stroke="none"
                  >
                    {" "}
                    <path d="M77 181 c-70 -73 -72 -95 -17 -145 47 -42 60 -44 97 -12 43 37 19 48 -29 14 -15 -10 -22 -8 -48 17 -38 36 -38 57 1 89 30 26 56 24 74 -4 9 -15 25 -12 25 5 0 8 -11 22 -25 31 -23 15 -24 18 -10 34 14 15 11 30 -5 30 -4 0 -32 -27 -63 -59z" />{" "}
                    <path d="M97 104 c-15 -15 8 -24 64 -24 46 0 59 3 59 15 0 12 -13 15 -58 15 -32 0 -62 -3 -65 -6z" />{" "}
                  </g>{" "}
                </svg>
              </a>
              {/* {Medium} */}
              <a
                target="_blank"
                href={siteConfig.social.medium}
                className="text-gray-800 dark:text-gray-200 hover:text-blue-500 dark:hover:text-blue-400"
              >
                <span className="sr-only">Medium</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 sm:h-1.15rem sm:w-1.15rem md:h-5 md:w-5 lg:h-5 lg:w-5"
                  fill="currentColor"
                  viewBox="0 0 448 512"
                  aria-hidden="true"
                >
                  {/*<!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.-->*/}
                  <path  fillRule="evenodd" d="M465.4 96C508.8 96 544 131.2 544 174.6L544 258.4C542.1 258.3 540.2 258.2 538.3 258.2L537.9 258.2C527.9 258.2 515.6 260.6 506.8 265C496.8 269.6 488.1 276.5 480.8 285.6C469 300.2 461.9 319.9 460.2 342C460.1 342.7 460.1 343.3 460 344C459.9 344.7 459.9 345.2 459.9 345.9C459.8 347.1 459.8 348.3 459.8 349.5C459.8 351.4 459.7 353.3 459.8 355.3C461 405.4 488 445.5 536.1 445.5C538.8 445.5 541.4 445.4 544 445.1L544 465.5C544 508.9 508.8 544.1 465.4 544.1L174.6 544C131.2 544 96 508.8 96 465.4L96 174.6C96 131.2 131.2 96 174.6 96L465.4 96zM178.3 202.9L178.6 203C191.8 206 198.4 210.4 198.4 226.4L198.4 413.6C198.4 429.6 191.7 434 178.5 437L178.2 437.1L178.2 439.9L231 439.9L231 437.1L230.7 437C217.5 434 210.8 429.6 210.8 413.6L210.8 237.3L296.9 439.8L301.8 439.8L390.4 231.6L390.4 418.2C389.3 430.8 382.6 434.7 370.7 437.4L370.4 437.5L370.4 440.2L462.3 440.2L462.3 437.5L462 437.4C450.1 434.7 443.3 430.8 442.1 418.2L442 226.4L442.1 226.4C442.1 210.4 448.8 206 462 203L462.3 202.9L462.3 200.2L390.1 200.2L323.1 357.6L256.1 200.2L178.3 200.2L178.3 202.9zM544 404.3C518.9 396.9 501 369.2 502.8 336.5L502.8 336.5L543.9 336.5L543.9 404.3zM537.6 268.7C539.9 268.7 542 269 544 269.6L544 327L503.8 327C505.3 293.4 517.4 269.1 537.6 268.7z" />
                </svg>
              </a>
            </div>
          </motion.div>
        </div>
        {/* Blob Shape */}

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9 }}
          className="basis-2/4  justify-center hidden mx-auto items-center md:hidden lg:flex sm:hidden xl:flex"
        >
          {/* Blob SVG */}
          <svg
            viewBox="0 0 170 200"
            xmlns="http://www.w3.org/2000/svg"
            className="w-[500px] h-[600px] z-5  overflow-hidden  fill-blue-600 dark:fill-blue-600"
          >
            <path
              transform="translate(100 85)"
              d="M41.4,-51.3C52,-40.4,57.8,-25.8,60.1,-10.9C62.3,4,61.1,19.3,55.4,34.8C49.8,50.4,39.8,66.2,24.3,75.7C8.8,85.3,-12.3,88.5,-30.9,82.7C-49.4,76.8,-65.4,61.9,-76.1,43.8C-86.7,25.6,-92,4.2,-85.9,-12.5C-79.8,-29.2,-62.2,-41.2,-46,-51.1C-29.8,-61,-14.9,-68.7,0.2,-69C15.4,-69.3,30.8,-62.1,41.4,-51.3Z"
            />
          </svg>

          {/* Image Positioned on Top of Blob */}
          {/*eslint-disable-next-line */}
          <img
            src={ProfileImage}
            alt="Your photo"
            className="absolute w-[371px] ml-7  mt-[4.7rem] rounded-[15rem]  "
          />
        </motion.div>
      </div>

      {/* MyJourneySection */}
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.2 }}
        className="myJourneyHeading flex flex-col items-center mt-20"
      >
        <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-5xl font-sans font-bold dark:text-white">
          My Journey
        </h1>
        <hr className="w-20 h-[.1rem] mt-1 flex justify-center bg-black border-0 dark:bg-white " />
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        className="relative w-full min-h-screen mt-14"
      >
        <div
          className="absolute left-1/2 transform -translate-x-1/2 w-1.5 rounded-full bg-gradient-to-b from-gray-400 via-gray-500 to-gray-600 dark:bg-gradient-to-b dark:from-blue-700 dark:via-purple-800 dark:to-indigo-900
 h-full"
        ></div>
        {myJourney.map((item, index) => {
          const isLeft = index % 2 === 0;
          return (
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 1, ease: "easeOut" }}
              key={index}
              className="relative w-full py-10 flex justify-center items-center"
            >
              {/* Dot in center */}
              <div className="absolute left-1/2 transform -translate-x-1/2 h-5 w-5 dark:bg-blue-900 bg-white border-4 border-blue-900 dark:border-white rounded-full z-10"></div>

              {/* Content Box */}
              <div
                className={`w-[40%] sm:w-[40%] md:w-[40%] lg:w-[45%] p-5 rounded-xl shadow-lg bg-gradient-to-br from-gray-100 via-gray-200 to-gray-300 dark:bg-gradient-to-br dark:from-indigo-600 dark:to-indigo-900 text-black dark:text-white z-10 ${
                  isLeft
                    ? "mr-auto  ml-2 sm:ml-4 md:ml-6 lg:ml-8 xl:ml-10"
                    : "ml-auto mr-2 sm:mr-4 md:mr-6 lg:mr-8 xl:mr-10"
                }`}
              >
                <h2 className="text-sm sm:text-base md:text-lg lg:text-xl font-bold">
                  {item.Title}
                </h2>
                <p className="text-xs sm:text-sm md:text-base opacity-70">
                  {item.Date}
                </p>
                <p className="text-xs sm:text-sm md:text-base lg:text-lg mt-2">
                  {item.Description}
                </p>

                {item.isImage ? (
                  <a
                    href="https://play.google.com/store/apps/details?id=com.jointerx.app"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className=" h-7.5 mt-2 sm:h-9 md:h-12 lg:h-14 "
                      src={playStoreBadge}
                      alt="Play Store Badge"
                    />
                  </a>
                ) : (
                  <p></p>
                )}
                {/* isButton Section*/}
                {item.isButton ? (
                  <div className="mt-4">
                    <a
                      href={item.Link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="md:px-4 md:py-2 sm:px-5 sm:py-2 px-4 py-2 text-xs sm:text-sm md:text-lg bg-gradient-to-r from-blue-500 to-purple-600 text-white font-semibold rounded-full"
                    >
                      {item.ButtonText}
                    </a>
                  </div>
                ) : (
                  <p></p>
                )}
              </div>
            </motion.div>
          );
        })}
      </motion.div>
      {/* MyJourney SectionEnds Here */}
    </div>
  );
}

export default Home;
